import { type Context, createContext } from 'react';

import type { ShareUpToMessageContextValue } from './shareUpToMessageTypes';

export const ShareUpToMessageContext: Context<ShareUpToMessageContextValue | undefined> =
	createContext<ShareUpToMessageContextValue | undefined>(undefined);
